module.exports = __webpack_public_path__ + "img/home-banner2.7e6bd56d.png";